import { render, staticRenderFns } from "./myfeedback.vue?vue&type=template&id=41ac92da&scoped=true"
import script from "./myfeedback.vue?vue&type=script&lang=js"
export * from "./myfeedback.vue?vue&type=script&lang=js"
import style0 from "./myfeedback.vue?vue&type=style&index=0&id=41ac92da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ac92da",
  null
  
)

export default component.exports